import ziperase from '../../services/ziperase';
import { notify } from '../../services/notify';

const state = {
  tasks: null,
  count: null,
  pollIntervalId: null,
  isLoading: false,
  showTasksHaveUpdates: false
};

const mutations = {
  tasks(state, tasks) {
    state.tasks = tasks;
  },
  count(state, count) {
    state.count = count;
  },
  setLoading(state, value) {
    state.isLoading = value;
  },
  setPollIntervalId(state, id) {
    state.pollIntervalId = id;
  },
  setTasksHaveUpdates(state, value) {
    state.showTasksHaveUpdates = value;
  }
};

const getters = {
  tasks: (state) => state.tasks,
  count: (state) => state.count,
  isLoading: (state) => state.isLoading,
  pollingInProgress: (state) => state.pollIntervalId != null,
  showTasksHaveUpdates: (state) => state.showTasksHaveUpdates
};

const actions = {
  async fetchTasks({ commit }) {
    commit('setLoading', true);
    try {
      const response = await ziperase.fetchTasks();
      if (response && response.data) {
        commit('tasks', response.data);
      }
    } catch (error) {
      notify().error('Failed to retrieve tasks.');
    } finally {
      commit('setLoading', false);
    }
  },

  startPolling({ dispatch, commit, state }) {
    if (state.pollIntervalId) return; // avoid re-polling when already in progress
    const id = setInterval(() => {
      dispatch('fetchTasks');
    }, 20000);
    commit('setPollIntervalId', id);
  },

  stopPolling({ commit, state }) {
    if (state.pollIntervalId) {
      clearInterval(state.pollIntervalId);
      commit('setPollIntervalId', null);
    }
  },

};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
